<template>
	<div id="PageLoginResStep">
		<div class="container content-login">
			<div class="row">
				<div class="col-12">
					<div class="wrapper-headlines">
						<div class="row justify-content-center">
							<div class="col-md-12 col-lg-auto">
								<h1 class="d-inline-block">&nbsp;</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>
						<div class="row justify-content-center headinline">
							<div class="col-md-12 col-lg-auto">
								<h1 class="d-inline-block">{{ $t('GLOBAL.GLOBAL.LOGIN') }}</h1>
							</div>
						</div>
						<form  @submit.prevent="processLogin" >
							<div class="row justify-content-center">
								<div class="col-xs-12 col-md-4">
									<CsInput
									ref="email"
									autocomplete="email"

									:placeholder="$t('Email address')"
									:id="'email'"
									:type="'email'"
									:name="'email'"
									v-model="form.email"
									></CsInput>
								</div>
								<div class="col-xs-12 col-md-4">
									<CsInput
									ref="password"
									autocomplete="password"

									:placeholder="$t('Password')"
									:id="'password'"
									:type="'password'"
									:name="'password'"
									v-model="form.password"
									></CsInput>
									<small class="input_description input_description--link" @click="forgotPassword">{{ $t('Passwort vergessen?') }}</small>
								</div>
								<div class="col-xs-12 col-md-4">
									<button type="submit" class="btn btn-primary btn-wp">
										{{ $t('Logging in') }}
									</button>
									
									
								</div>
							</div>
						</form>
						
						<div class="row justify-content-center">

							<div class="col-md-12">

								<p>Du hast noch keinen Account? <router-link :to="{name: 'PageRegister'}">Jetzt kostenlos erstellen</router-link></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'PageLoginResStep',
	props: {
		redirect_back: {
			default: false
		},
	},
	computed: {
		...mapGetters('orm', [
			'groups',
	    ]),

		...mapGetters('orm/reservation', {
	    	resStation: 'station',
			resStartdate: 'startdate',
			resEnddate: 'enddate',
			resCar: 'car',
			resNavigation: 'navigation',

	    }),
	},
	data(){
		return {
			form: {
				email: 		'',
				password: 	'',
			}
		}
	},
	mounted(){
		if (!this.resStation) {
			this.$store.commit('orm/reservation/SET_NAVIGATION', false);
		}
	},

	methods: {
		processLogin(e){
			var self = this;
			this.$store.dispatch('orm/LOGIN_CUSTOMER', {
				email: this.form.email,
				password: this.form.password
			}).then(res => {
				if(self.$route.params.redirect){
					self.$router.push({name: "PagePlace"});
				} else {
					self.$router.push({name: "PagePlace"});	
				}
				
			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
		},
		forgotPassword(e){
			var self = this;
			this.$store.dispatch('orm/RESET_CUSTOMER_PASSWORD', {
				email: this.form.email
			}).then(res => {
			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })
		},

		/**
		 * processPostLogin wenn wir im bestellprozess sind, redirecte zum bestell prozess
		 */
		processPostLogin(){

		},
	}
}
</script>





// WEBPACK FOOTER //
// src/components/Pages/PageLoginResStep.vue